import { cloneElement } from 'react';
import classNames from 'classnames';
// eslint-disable-next-line no-unused-vars
import css from './squared.css';

export default function Squared({ children }) {
  const className = classNames([children.props.className, 'squared']);
  return cloneElement(children, { className });
}
